/**************************************************
 * Nombre:       Seccion_PQRSF
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Pqrsf_Portada from "./Componentes/Pqrsf_Portada";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_PQRSF = () => {

    useEffect(() => {
        irArriba()
    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Pqrsf_Portada/>
            </Grid>


        </Grid>
    )

}
export default Seccion_PQRSF